import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { regularFontSizeAnimation, smallFontSizeAnimation } from '@app/shared/animations/font-size.animations';
import { ButtonModule } from 'primeng/button';
import { ClassNames } from 'primeng/classnames';

@Component({
  selector: 'app-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  styleUrl: './sidebar-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [regularFontSizeAnimation, smallFontSizeAnimation],
  imports: [ButtonModule, ClassNames],
})
export class SidebarFooterComponent {
  public readonly isSidebarOpen = input.required<boolean>();
  public readonly userData = input<any | null>(null);

  public readonly logout = output<void>();

  public get initials(): string {
    const userData = this.userData();
    return `${userData?.firstName?.charAt(0) || ''}${userData?.lastName?.charAt(0) || ''}`.toLocaleUpperCase();
  }
}
